var dsox = dsox || {};
dsox.Search = (function () {
    
    var searchModule = function ($) {
        $(document).on('click', '.js-search-toggle', function(e){
            e.preventDefault();
            $('.search-form').addClass('search-form-visible');
            $('.search-input').focus();
        });

        $(document).on('click', '.navbar-toggler[aria-label="Toggle search"]', function(e){
            e.preventDefault();
            $('.search-form').addClass('search-form-visible');
            $('.search-input').focus();
        })

        $(document).on('click', '.js-search-close', function(e){
            e.preventDefault();
            $('.search-form').removeClass('search-form-visible');
            $('.search-input').val('');
            $('.js-search-toggle').focus();
        })
    }
    
    return {
		searchModule : searchModule
	}
}());